import './Button.css';

function Button({ 
    children, 
    onClick, 
    className = '', 
    isActive = false,
    as = 'button',
    href,
    target,
    rel,
    ...props 
}) {
    const baseClass = `custom-button ${isActive ? 'active' : ''} ${className}`;

    if (as === 'a') {
        return (
            <a 
                href={href}
                className={baseClass}
                target={target}
                rel={rel}
                {...props}
            >
                {children}
            </a>
        );
    }

    return (
        <button 
            onClick={onClick} 
            className={baseClass}
            {...props}
        >
            {children}
        </button>
    );
}

export default Button;